"use client"

import {Link, usePathname, useRouter} from "@pata/i18n";
import {Locale, useLocale} from "next-intl";

export type Props = {
    locale: Locale;
    title: string;
}

export default function LocaleSwitcherSelect(props: Props) {
    const pathname = usePathname();
    const locale = useLocale();
    const router = useRouter();
    const isActive = locale === props.locale;
    
    return (
        <>
            <li className={isActive ? 'active' : ''}>
                <Link href={pathname} locale={props.locale} onClick={(e) => {
                    e.preventDefault()
                    
                    router.replace(pathname, {locale: props.locale});
                    router.refresh();
                }}><span>{props.title}</span></Link>
            </li>
            <li>
                <span className="seperator">/</span>
            </li>
        </>
    )
}